
export class NoteTypes {
  static consult_note = "consult_note"
  static general_clinical_note = "general_clinical_note"
  static general_dental_note = "general_dental_note"
  static dental_followup_note = "dental_followup_note"
  static dental_emergency_note = "dental_emergency_note"
  static dental_patient_handout = "dental_patient_handout"
  static dental_referral_letter = "dental_referral_letter"
  static orthodontic_note = "orthodontic_note"
  static prosthodontic_note = "prosthodontic_note"
  static orthodontic_followup_note = "orthodontic_followup_note"
  static dental_hygenist_note = "dental_hygenist_note"
  static periodontal_note = "periodontal_note"
  static medical_note = "medical_note"
  static medical_patient_handout = "medical_patient_handout"
  static medical_referral_letter = "medical_referral_letter"
  static smart_dictation = "smart_dictation"

  static dr_wong_my_teeth_today = "dr_wong_my_teeth_today"
  static dr_wong_note_four_gl = "dr_wong_note_four_gl"
  static dr_wong_note_one = "dr_wong_note_one"
  static dr_wong_note_three_sealant = "dr_wong_note_three_sealant"
  static dr_wong_note_two_sdf = "dr_wong_note_two_sdf"

  static dr_manji_consult_with_eights = "dr_manji_consult_with_eights"

  static fa_endontics_consult_note = "fa_endontics_consult_note"
  static fa_endontics_pulpectomy_note = "fa_endontics_pulpectomy_note"
  static fa_endontics_treatment_note = "fa_endontics_treatment_note"

  static dr_sidon_clinical_note = "dr_sidon_clinical_note"

  static abel_periodontal_chart = "abel_periodontal_chart" 
  static abel_odontogram_beta = "abel_odontogram_beta" 
  static abel_restorative_chart = "abel_restorative_chart" 
  static abel_hygienist_chart_beta = "abel_hygienist_chart_beta" 
  static abel_referral_reply = "abel_referral_reply" 
  static tooth_aura_dental_hygienist_note = "tooth_aura_dental_hygienist_note" 
  static dr_fritz_implant_consult_letter = "dr_fritz_implant_consult_letter" 
  static dr_fritz_pathology_consult_letter = "dr_fritz_pathology_consult_letter" 
  static dr_fritz_grafting_consult_letter = "dr_fritz_grafting_consult_letter" 

  static dr_harle_complete_exam = "dr_harle_complete_exam"
  static dr_harle_restorative = "dr_harle_restorative"
  static dr_harle_emergency = "dr_harle_emergency"
  static dr_harle_hygiene_recall = "dr_harle_hygiene_recall"
  static dr_harle_scale_appointment = "dr_harle_scale_appointment"
  static dr_harle_extraction_treatment = "dr_harle_extraction_treatment"
  static dr_harle_ortho_appointment = "dr_harle_ortho_appointment"
  static dr_harle_orthodontic_records = "dr_harle_orthodontic_records"
  static dr_harle_prosthodontic_treatment = "dr_harle_prosthodontic_treatment"

  static wpd_recall_exam_dr_luong = "wpd_recall_exam_dr_luong"
  static wpd_recall_exam_dr_dufresne = "wpd_recall_exam_dr_dufresne"
  static wpd_np_exam_dr_luong = "wpd_np_exam_dr_luong"
  static wpd_np_exam_dr_dufresne = "wpd_np_exam_dr_dufresne"
  static wpd_specific_exam_dr_luong = "wpd_specific_exam_dr_luong"
  static wpd_specific_exam_dr_dufresne = "wpd_specific_exam_dr_dufresne"
  static wpd_scaling_visit = "wpd_scaling_visit"
  static wpd_or_note = "wpd_or_note"

  static love_dental_shay_template = "love_dental_shay_template"

  static dr_seitz_restorative_medicine = "dr_seitz_restorative_medicine"
}

const WPD = [
  "liline.dufresne@gmail.com",
  "ngockluong@gmail.com",
]

const dr_harle_emails = [
  "cmanningdrharle@gmail.com",
  "natsis@nrtco.net",
  "bsandrelli@hotmail.com",
  "ainsleymelmoth@hotmail.com",
  "suralvoortho@gmail.com",
  "lamr44@gmail.com",
  "lexileal@hotmail.com",
]

export class PrivateMapping {
  static dr_wong = [NoteTypes.dr_wong_note_one, NoteTypes.dr_wong_note_two_sdf, NoteTypes.dr_wong_note_three_sealant, NoteTypes.dr_wong_note_four_gl, NoteTypes.dr_wong_my_teeth_today]
  static dr_manji = [NoteTypes.dr_manji_consult_with_eights]
  static evergreen_dental = [NoteTypes.dr_sidon_clinical_note]
  static fa_endontics = [NoteTypes.fa_endontics_consult_note, NoteTypes.fa_endontics_pulpectomy_note, NoteTypes.fa_endontics_treatment_note]
  static gulshan_deep = [NoteTypes.tooth_aura_dental_hygienist_note]
  static dr_fritz = [NoteTypes.dr_fritz_implant_consult_letter, NoteTypes.dr_fritz_pathology_consult_letter, NoteTypes.dr_fritz_grafting_consult_letter]
  static dr_harle = [NoteTypes.dr_harle_complete_exam, NoteTypes.dr_harle_restorative, NoteTypes.dr_harle_emergency, NoteTypes.dr_harle_hygiene_recall, NoteTypes.dr_harle_scale_appointment, NoteTypes.dr_harle_extraction_treatment, NoteTypes.dr_harle_ortho_appointment, NoteTypes.dr_harle_orthodontic_records, NoteTypes.dr_harle_prosthodontic_treatment]
  static wpd = [NoteTypes.wpd_recall_exam_dr_luong, NoteTypes.wpd_recall_exam_dr_dufresne, NoteTypes.wpd_np_exam_dr_luong, NoteTypes.wpd_np_exam_dr_dufresne, NoteTypes.wpd_specific_exam_dr_luong, NoteTypes.wpd_specific_exam_dr_dufresne, NoteTypes.wpd_scaling_visit, NoteTypes.wpd_or_note]
  static love_dental = [NoteTypes.love_dental_shay_template]
  static dr_seitz = [NoteTypes.dr_seitz_restorative_medicine]

  static private_notes_by_email(email) {
    if (!email || email === "null") {
      return false;
    }

    return Object.keys(PrivateMapping).filter((integrations) => {
      if (email.includes("@medxinsight.com")) {
        return true;
      } 
      switch(integrations) {
        case "dr_wong": {
          return email === "hello@dentalgarten.com";
        }
        case "dr_manji": {
          return email === "zain.manji1@gmail.com";
        }
        case "evergreen_dental": {
          return email === "hello@evergreendentalcare.ca";
        }
        case "fa_endontics": {
          return email === "info@fourthaveendodontics.com";
        }
        case "gulshan_deep": {
          return email === "gulshandeepb@gmail.com";
        }
        case "dr_fritz": {
          return email === "larissa@drpeterfritz.com";
        }
        case "dr_harle": {
          return dr_harle_emails.includes(email);
        }
        case "wpd": {
          return WPD.includes(email);
        }
        case "love_dental": {
          return email === "info@lovedental.ca";
        }
        case "dr_seitz": {
          return email === "drrob@corktowndental.com";
        }
      }
    })
  }
}

export const PDF_FORMS = [
  
]

export class NoteSections {
  static abel_notes = [
    NoteTypes.general_clinical_note, 
    NoteTypes.general_dental_note, 
    NoteTypes.dental_followup_note, 
    NoteTypes.dental_emergency_note, 
    NoteTypes.dental_patient_handout, 
    NoteTypes.dental_referral_letter, 
    NoteTypes.orthodontic_note, 
    NoteTypes.prosthodontic_note, 
    NoteTypes.orthodontic_followup_note, 
    NoteTypes.dental_hygenist_note, 
    NoteTypes.periodontal_note, 
    NoteTypes.medical_note, 
    NoteTypes.medical_patient_handout, 
    NoteTypes.medical_referral_letter, 
    NoteTypes.smart_dictation,
    NoteTypes.abel_hygienist_chart_beta,
    NoteTypes.abel_odontogram_beta,
    NoteTypes.abel_periodontal_chart,
    NoteTypes.abel_referral_reply,
    NoteTypes.abel_restorative_chart
  ]
    static using_note_type(noteType) {
        // Iterate over the class's static properties
        return Object.entries(NoteSections)
            .filter(([/* unused */, noteTypes]) => Array.isArray(noteTypes) && noteTypes.includes(noteType))
            .map(([sectionName]) => sectionName); // Return the section names
    }

    // Show em all
    static show_all_note_sections_no_pdf_no_beta() {
        return Object.keys(NoteSections).filter(
          (sectionName) => sectionName !== "beta"
        );
      }
}